import React, { Fragment } from "react";

import { OnlineDevicesInfo } from "../onlineDevicesInfo";
import {
  MobileSort,
  TableSearch,
} from "../../../../../../../components/table/components";
import { Mobile } from "../../../../../../../hocs/Responsive";

export const OnlineDevicesTableHeader = () => {
  return (
    <Fragment>
      <OnlineDevicesInfo />
      <TableSearch />

      <Mobile>
        <MobileSort />
      </Mobile>
    </Fragment>
  );
};
